module.exports = new __parcel__URL__("infrastructure-crane.3c8e069d.svg").toString();